const init = JSON.parse(localStorage.getItem('init'));
const product_metafields = init ? init.product_metafields.map(metafield => {
  return `{namespace: "${metafield.namespace}", key: "${metafield.key}"}`
}) : [];

export const productByHandleQuery = `query productByHandle($handle: String!) { 
  productByHandle(handle: $handle) {
    id
    createdAt
    updatedAt
    descriptionHtml
    description
    handle
    tags
    productType
    title
    vendor
    publishedAt
    onlineStoreUrl
    requiresSellingPlan
    featuredImage {
      url
      id
      altText
    }
    options {
      name
      values
    }
    favorites_count: metafield(namespace: "favorites_count", key: "counter") {
      id
      value
    }
    product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
      key
      value
    }
    images(first: 25) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          src
          altText
        }
      }
    }
    variants(first: 10) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          title
          priceV2 {
            amount
            currencyCode
          }
          weight
          available: availableForSale
          sku
          image {
            id
            originalSrc
            altText
          }
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
}`

export const getProductsByTagQuery = `query getProducts($first: Int!, $query: String!, $sortKey: ProductSortKeys!, $reverse: Boolean!) {
  products (first: $first, query: $query, sortKey: $sortKey, reverse: $reverse) {
    edges {
      node {
        id
        createdAt
        updatedAt
        descriptionHtml
        description
        handle
        tags
        productType
        title
        vendor
        publishedAt
        onlineStoreUrl
        requiresSellingPlan
        featuredImage {
          url
          id
          altText
        }
        options {
          name
          values
        }
        favorites_count: metafield(namespace: "favorites_count", key: "counter") {
          id
          value
        }
        product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
          key
          value
        }
        images(first: 25) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              id
              src
              altText
            }
          }
        }
        variants(first: 10) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            cursor
            node {
              id
              title
              priceV2 {
                amount
                currencyCode
              }
              weight
              available: availableForSale
              sku
              image {
                id
                originalSrc
                altText
              }
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  }
}`

export const getProductsQuery = `query Products($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      createdAt
      updatedAt
      descriptionHtml
      description
      handle
      tags
      productType
      title
      vendor
      publishedAt
      onlineStoreUrl
      requiresSellingPlan
      featuredImage {
        url
        id
        altText
      }
      options {
        name
        values
      }
      favorites_count: metafield(namespace: "favorites_count", key: "counter") {
        id
        value
      }
      product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
        key
        value
      }
      images(first: 25) {
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        edges {
          cursor
          node {
            id
            src
            altText
          }
        }
      }
      variants(first: 10) {
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        edges {
          cursor
          node {
            id
            title
            priceV2 {
              amount
              currencyCode
            }
            weight
            available: availableForSale
            sku
            image {
              id
              originalSrc
              altText
            }
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
  }
}`